import { createSlice } from '@reduxjs/toolkit';

const ensureCall = (state, callerId) => {
  if (!callerId) return;
  if (!state.calls[callerId]) {
    state.calls[callerId] = {
      visible: false,
      pinJobID: null,
      midasConferenceNumber: null,
      sessionStartedAt: null,
      callSessionKey: null,
    };
  }
};

const textToVoiceSlice = createSlice({
  name: 'textToVoice',
  initialState: {
    calls: {},
  },
  reducers: {
    activateInput: (state, action) => {
      const callerId = action.payload;
      ensureCall(state, callerId);
      state.calls[callerId].visible = true;
    },
    deactivateInput: (state, action) => {
      const callerId = action.payload;
      ensureCall(state, callerId);
      state.calls[callerId].visible = false;
    },
    setSessionData: (state, action) => {
      const {
        callerId,
        pinJobID = null,
        midasConferenceNumber = null,
        callSessionKey,
      } = action.payload || {};
      ensureCall(state, callerId);
      if (!callerId) return;

      if (pinJobID) state.calls[callerId].pinJobID = pinJobID;
      if (midasConferenceNumber)
        state.calls[callerId].midasConferenceNumber = midasConferenceNumber;
      if (typeof callSessionKey !== 'undefined') {
        state.calls[callerId].callSessionKey = callSessionKey;
      }
      if (!state.calls[callerId].sessionStartedAt) {
        state.calls[callerId].sessionStartedAt = Date.now();
      }
    },
    clearSession: (state, action) => {
      const callerId = action.payload;
      if (!callerId) return;
      delete state.calls[callerId];
    },
  },
});

export const { activateInput, deactivateInput, setSessionData, clearSession } =
  textToVoiceSlice.actions;

export const textToVoiceReducer = textToVoiceSlice.reducer;
export default textToVoiceReducer;
